// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    idList: [],
    activeTab: 0,
    flag:false,
  },
  mutations: {
    addToIdList(state, data) {
      state.idList.push(data);
      state.flag=true;
    },
    reduceToIdList(state, data) {
      const index = state.idList.indexOf(data);
      state.flag=true;
      if (index !== -1) {
        state.idList.splice(index, 1);
      }
    },


    
    setActiveTab(state, tab) {
      state.activeTab = tab;
    }
  }
});

export default store;
